// extracted by mini-css-extract-plugin
export var anchor = "bm_d4";
export var anchors = "bm_d3";
export var document = "bm_d7";
export var documents = "bm_d6";
export var heading = "bm_G";
export var privacy = "bm_d5";
export var section = "bm_j";
export var tariff = "bm_d9";
export var tariffs = "bm_d8";